<div class="panelEditTerritories" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" id="panelTerritoryContainer">
    <div *ngIf="!isLoading" class="panelEditTerritories">

        <div class="header-panel">
            <div class="btnClose">
                <mat-icon (click)="ClosePanel()">arrow_back_ios</mat-icon>
                <!-- <img [src]="'cancelar.svg' | findUrl" (click)="ClosePanel()"> -->
            </div>
            <h3>Simulación de Territorio</h3>
            <span class="badge-locations" *ngIf="getTotalLocationsCount() > 0">{{getTotalLocationsCount()}} ubicaciones</span>
        </div>

        <div class="step-container">
            <div class="step-header">
                <span class="step-badge">2</span>
                <h4 class="step-title">Ver detalles y simular territorios</h4>
            </div>
        </div>

        <mat-tab-group class="territories-tabs" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChanged($event)">
            <mat-tab *ngFor="let territory of selectedTerritories; let i = index">
                <ng-template mat-tab-label>
                    <span [style.color]="territory.idTerritory | territoryAssignedColor">{{ territory.idTerritory }}</span>
                </ng-template>
                <div class="territory-details-section" [style.border]="'1px solid ' + (territory.idTerritory | territoryAssignedColor)">
                    <div class="detail-card">
                        <mat-icon class="detail-icon">badge</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">ID TERRITORIO</span>
                            <span class="detail-value" [style.color]="territory.idTerritory | territoryAssignedColor">{{ territory.idTerritory }}</span>
                        </div>
                    </div>
                    <div class="detail-card">
                        <mat-icon class="detail-icon">location_on</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">REGIÓN</span>
                            <span class="detail-value">{{ territory.region || 'N/A' }}</span>
                        </div>
                    </div>
                    <div class="detail-card">
                        <mat-icon class="detail-icon">route</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">TIPO RUTA</span>
                            <span class="detail-value">{{ territory.routeType }}</span>
                        </div>
                    </div>
                    <div class="detail-card">
                        <mat-icon class="detail-icon">location_on</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">ZONA</span>
                            <span class="detail-value">{{ territory.zone || 'N/A' }}</span>
                        </div>
                    </div>
                    <div class="detail-card">
                        <mat-icon class="detail-icon">calendar_today</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">DÍA / FRECUENCIA</span>
                            <span class="detail-value">{{ territory.visitDay }} - {{ territory.routeFrequency }}</span>
                        </div>
                    </div>
                    <div class="detail-card">
                        <mat-icon class="detail-icon">assessment</mat-icon>
                        <div class="detail-content">
                            <span class="detail-label">SATURACIÓN</span>
                            <span class="detail-value" [style.color]="territory.saturation | saturationColor">{{ territory.saturation }}</span>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <div class="territoriesLocations-toolbar">
            <div class="toolbar-left">
                <mat-icon class="info-icon" 
                          matTooltip="Selecciona ubicaciones haciendo click en el mapa o usa la selección por área. Arrastra entre territorios para asignar."
                          matTooltipPosition="below">
                    info_outline
                </mat-icon>
                <span class="toolbar-title">Editar ubicaciones</span>
            </div>
            <div class="toolbar-actions">
                <button mat-icon-button class="draw-button" [class.selected]="this.isPolygonDrawActive" (click)="togglePolygonDraw()" aria-label="Selección por área">
                    <mat-icon class="draw-button-icon">select_all</mat-icon> Selección/área
                </button>
                <button mat-icon-button class="refresh-button" (click)="resetTerritoriesAndLocations()" aria-label="Refrescar">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>
        <div class="territoriesLocations-section" cdkDropListGroup>
            <div class="territory-row" *ngFor="let territory of selectedTerritories">
                <div class="territory-row-header" cdkDropList [id]="'header-' + territory.idTerritory" [cdkDropListData]="[]" cdkDropListOrientation="horizontal">
                    <span class="territory-row-title" [style.color]="territory.idTerritory | territoryAssignedColor">{{ territory.idTerritory }}</span>
                    <span class="territory-row-move-all" cdkDrag [cdkDragData]="{ territoryId: territory.idTerritory, isMoveAll: true }" [cdkDragDisabled]="!territoriesLocationsTray[territory.idTerritory]?.length"> 
                        Mover todas 
                    </span>
                    <span class="territory-row-count"> seleccionadas: {{ territoriesLocationsTray[territory.idTerritory]?.length || 0 }} </span>
                </div>
                <div class="territory-row-locations" cdkDropList [cdkDropListData]="territoriesLocationsTray[territory.idTerritory]" (cdkDropListDropped)="onDrop($event, territory.idTerritory)" cdkDropListOrientation="horizontal">
                    <div class="locationCard" *ngFor="let item of territoriesLocationsTray[territory.idTerritory]" cdkDrag>
                        <div class="locationCard-icon" (click)="onCardClicked(item)">
                            <img [src]="'bussineLocation.png' | findUrl">
                        </div>
                        <div class="locationCard-info" >
                            <span class="locationCard-title">{{ item.identifier }}</span>
                            <span class="locationCard-subtitle">{{ item.description }}</span>
                        </div>
                        <div class="locationCard-delete" (click)="removeLocation(territory.idTerritory, item)">
                            <mat-icon>delete</mat-icon>
                        </div>
                        
                        <!-- Placeholder personalizado mientras se arrastra -->
                        <div class="locationCard-placeholder" *cdkDragPlaceholder></div>
                    </div>
                </div>
            </div>
            <div class="no-results" *ngIf="selectedTerritories.length == 0 && !isLoading">
                <span class="no-results-text">No se encontraron territorios</span>
            </div>

        </div>

    </div>

    <div class="skeletonLoader" *ngIf="isLoading">
        <div class="panelTerrtories">
            <div class="header-panel">
                <div class="btnClose">
                    <ngx-skeleton-loader count="1" appearance="circle"
                        [theme]="{ 'width': '24px', 'height': '24px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </div>
                <ngx-skeleton-loader count="1" appearance="line"
                    [theme]="{ 'border-radius': '8px', 'height': '20px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" appearance="line"
                    [theme]="{ 'border-radius': '12px', 'height': '24px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
            </div>
    
            <div class="territory-details-section">
                <div class="detail-row" *ngFor="let i of [1,2,3,4,5,6,7]">
                    <span class="detail-label">
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{ 'border-radius': '8px', 'height': '14px', 'width': '50px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </span>
                    <span class="detail-value">
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{ 'border-radius': '8px', 'height': '14px', 'min-width': '50px','max-width': '80px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </span>
                </div>
            </div>
    
            <div class="territoriesLocations-section">
                <div class="search-Arrow-flex">
                    <div style="width: 90%; height: 40px; margin-bottom: 5px;">
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{ 'border-radius': '8px', 'height': '40px', 'width': '100%', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </div>
                </div>
    
                <div class="territoriesLocations-list">
                    <div class="locationCard" *ngFor="let i of [1,2,3,4,5]">
                        <div class="locationCard-icon">
                            <ngx-skeleton-loader count="1" appearance="circle"
                                [theme]="{ 'width': '28px', 'height': '28px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                        <div class="locationCard-info">
                            <ngx-skeleton-loader count="1" appearance="line"
                                [theme]="{ 'border-radius': '8px', 'height': '14px', 'width': '120px', 'background-color': '#bdbdbd', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line"
                                [theme]="{ 'border-radius': '8px', 'height': '12px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                        <div class="locationCard-delete">
                            <ngx-skeleton-loader count="1" appearance="circle"
                                [theme]="{ 'width': '24px', 'height': '24px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isPolygonDrawActive">
    <div>
        <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonButtonMsg" [isVisible]="isPolygonButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
        <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container-top" [Mensaje]="polygonFinishMsg" [isVisible]="!isPolygonButtonMsgVisible"></app-tooltip>
    </div>
</ng-container>